import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

/**
 *
 * @returns {공개 유무 - 미공개, 공개}
 */
interface IProps {
  value: number | string;
  confirm?: Array<string> | string;
}
const PublicState: React.FC<IProps> = ({ value, confirm }) => {
  return (
    <>
      {confirm ? (
        <StateColor value={value}>
          {' '}
          {value === 1 || value === '1' ? '확인' : '미확인'}
        </StateColor>
      ) : (
        <StateColor value={value}>
          {value === 1 || value === '1' ? '공개' : '미공개'}
        </StateColor>
      )}
    </>
  );
};

export default PublicState;

const StateColor = styled.p`
  color: ${(props) =>
    props.value === 1 || props.value === '1'
      ? theme.colors.black
      : theme.colors.gray_3};
`;
